import { AuthenticationUserResponse } from '../interfaces/authentication-user.response';
import { Permission } from '../../permission/models/permission.model';
import { AuthenticationProfile } from './authentication-profile.model';

export class AuthenticationUser {
  public id: number;
  public email: string;
  public profile: AuthenticationProfile;
  public permissions: Permission[] = [];

  constructor(response?: AuthenticationUserResponse) {
    if (response) {
      this.id = response.id;
      this.email = response.email;

      if (response.profile && response.profile.data) {
        this.profile = new AuthenticationProfile(response.profile.data);
      }
      this.permissions =
        response.permissions && response.permissions.data
          ? response.permissions.data.map((resp) => new Permission(resp))
          : [];
    }
  }

  public get isAdmin(): boolean {
    throw new Error('Not implemented!');
  }

  public get displayName(): string {
    return this.profile ? `${this.profile.firstName} ${this.profile.lastName} (${this.email})` : '-';
  }
}
